import React from 'react';
import { theme, Col } from 'antd';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import LibraryLayout from 'components/Layouts/LibraryLayout';
import { RootState } from 'store/configureStore';
import { dataEntryAreas } from 'constants/dataEntryConstants';
import CardComponent from 'components/CardComponent';
import * as Styled from './LibraryDataEntry.styled';

const { useToken } = theme;

const LibraryDataEntry: React.FC = () => {
  const { token } = useToken();
  const { t } = useTranslation();

  const { scheme } = useSelector((state: RootState) => ({
    scheme: state.global.scheme
  }));

  return (
    <LibraryLayout>
      <Styled.ContentWrapper token={token} scheme={scheme}>
        <Styled.DataEntryRow gutter={[24, 24]}>
          {dataEntryAreas.map((area) => (
            <Col xs={24} sm={12} md={6} lg={4} key={area.id}>
              <CardComponent
                area={t(area.title)}
                infoText={t(area.description)}
                imgSrc=''
                className='library-card'
                href={area.path}
                textOnTop=''
              />
            </Col>
          ))}
        </Styled.DataEntryRow>
      </Styled.ContentWrapper>
    </LibraryLayout>
  );
};

export default LibraryDataEntry;
